<template>
  <tr v-if="editMode">
    <td><input :disabled="disabled" type="text" v-model="newDevice.device_id" class="form-control"></td>
    <td><input :disabled="disabled" type="text" v-model="newDevice.in_use_by" class="form-control"></td>
    <td><button :disabled="disabled" class="btn btn-success" @click="update"><i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-check', 'mr-5']"></i>{{'save' | translate}}</button>
    <button :disabled="disabled" class="btn btn-danger" @click="remove"><i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-trash', 'mr-5']"></i>{{'delete' | translate}}</button>
    <button :disabled="disabled" class="btn btn-danger btn-active" @click="cancel"><i :class="['fa', loading ? 'fa-spinner fa-spin' : 'fa-ban', 'mr-5']"></i>{{'cancel' | translate}}</button>
    </td>
  </tr>
  <tr v-else>
    <td><span v-if="parentLoading" class="text-muted"><i class="fa fa-spinner fa-spin mr-5"></i>{{newDevice.device_id}}</span> <span v-else>{{device.device_id}}</span></td>
    <td><span v-if="parentLoading" class="text-muted"><i class="fa fa-spinner fa-spin mr-5"></i>{{newDevice.in_use_by}}</span> <span v-else>{{device.in_use_by}}</span></td>
    <td><button :disabled="disabled || parentLoading" class="btn btn-info" @click="toggleMode"><i class="fa fa-edit mr-5"></i>{{'edit' | translate}}</button></td>
  </tr>
</template>
<script>
export default {
  props: ['original', 'storeId', 'parentLoading'],
  data () {
    return {
      disabled: false,
      editMode: false,
      loading: false
    }
  },
  computed: {
    device () {
      return this.original
    },
    newDevice () {
      return {...this.original}
    }
  },
  methods: {
    cancel () {
      this.toggleMode()
    },
    toggleMode () {
      this.editMode = !this.editMode
    },
    update () {
      this.disabled = true
      this.loading = true
      API.put(`accounting/stores/${this.storeId}/wsDevices/${this.device.id}`, this.newDevice)
        .then(res => {
          this.$emit('loading')
          this.$emit('reload')
          this.disabled = false
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!', icon: 'icon fa fa-check', show: true})
          this.editMode = false
          this.loading = false
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'danger', dismiss: 4, message: 'Error!', icon: 'icon fa fa-ban', show: true})
          this.disabled = false
        })
    },
    remove () {
      this.disabled = true
      this.loading = true
      API.delete(`accounting/stores/${this.storeId}/wsDevices/${this.device.id}`)
        .then(res => {
          this.disabled = false
          this.$emit('loading')
          this.$emit('reload')
          this.editMode = false
          this.loading = false
          this.$store.commit('pushAlert', {type: 'success', dismiss: 4, message: 'Success!', icon: 'icon fa fa-check', show: true})
        })
        .catch(error => {
          this.$store.commit('pushAlert', {type: 'danger', dismiss: 4, message: 'Error!', icon: 'icon fa fa-ban', show: true})
          this.disabled = false
        })
    }
  },
  watch: {
    parentLoading () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tools/TableRows/StoreDevicesRow.vue